/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Conversation_Tips_TitleInputs */



/**
* | output |
* | --- |
* | "Conversation tips" |
*
* @param {Nudge_Ask_Conversation_Tips_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_conversation_tips_title = /** @type {((inputs?: Nudge_Ask_Conversation_Tips_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Conversation_Tips_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Gesprekstips")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Conseils de conversation")
	return /** @type {LocalizedString} */ ("Conversation tips")
});